import {FormEvent, useState} from 'react';
import {useCookies} from 'react-cookie';
import {AxiosError} from 'axios';
import {APIService} from './APIService';

const flsId = 'fls_id';

const Register = () => {
  const [_cookie, setCookie] = useCookies([flsId]);
  const apiService = new APIService();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    let userContactID = '';

    try {
      e.preventDefault();
      const flashyResponse = await apiService.createFlashyContact(
        lastName,
        lastName,
        email,
        phone,
      );
      if (flashyResponse.contactID) {
        userContactID = flashyResponse.contactID;
      }
      const user = await apiService.createNewUser(
        flashyResponse.contactID,
        flashyResponse.firstName,
        flashyResponse.lastName,
        flashyResponse.email,
        flashyResponse.phone,
      );
      if (user.contactID) {
        userContactID = user.contactID;
      }
    } catch (e) {
      if (e instanceof AxiosError) {
        if (e.response?.data.errorCode === -22) {
          alert('User already exists');
        } else if (e.response?.data.errorCode === -31) {
          alert('Flashy api error');
        }
      } else {
        alert('Something went wrong');
      }
    } finally {
      if (userContactID) {
        setCookie(flsId, userContactID);
      }
      window.location.replace('/');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label htmlFor="firstName" className="form-label">First name</label>
        <input className="form-control" type="text" id="firstName" aria-label="default input example" value={firstName}
               onChange={(e) => setFirstName(e.target.value)} required/>
      </div>
      <div className="mb-3">
        <label htmlFor="lastName" className="form-label">Last name</label>
        <input className="form-control" type="text" id="lastName" aria-label="default input example" value={lastName}
               onChange={(e) => setLastName(e.target.value)} required/>
      </div>
      <div className="mb-3">
        <label htmlFor="email" className="form-label">Email</label>
        <input type="email" className="form-control" id="email" aria-describedby="emailHelp" value={email}
               onChange={(e) => setEmail(e.target.value)} required/>
      </div>
      <div className="mb-3">
        <label htmlFor="phone" className="form-label">Phone</label>
        <input className="form-control" type="text" id="phone" aria-label="default input example" value={phone}
               onChange={(e) => setPhone(e.target.value)} required/>
      </div>
      <button type="submit" className="btn btn-primary">Submit</button>
    </form>
  );
};

export default Register;